import React from 'react';
import { piiProps } from 'src/components/DemoBlur';
import CallButton from 'src/components/outbound/CallButton';

// Standalone Phone column (split email/phone mode). Tagged PII for demo mode.
export const phoneNumberCell = {
    field: 'phone',
    headerName: 'Phone',
    width: 120,
    minWidth: 100,
    editable: true,
    sortable: false,
    align: 'left',
    // Call opens the one dialer pre-filled with this lead (CU-869fmbgfj).
    renderCell: (params) => (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
            <span {...piiProps}>{params?.formattedValue ?? params?.value ?? ''}</span>
            <CallButton to={params?.row?.phone || ''} leadId={params?.row?.lead_id || null} sx={{ p: 0.25 }} />
        </span>
    ),
};

export const actionColumnData = {
    field: 'actions',
    type: 'actions',
    headerName: 'More',
    width: 45,
    minWidth: 45,
    maxWidth: 45,
    align: 'center',
};

export const referralFieldColumnData = {
    field: 'referral',
    headerName: 'Referral',
    sortable: false,
    width: 100,
    minWidth: 70,
};
export const treatmentFieldColumnData = {
    field: 'treatment',
    headerName: 'Treatment',
    sortable: false,
    width: 170,
    minWidth: 160,
};

export const initialPaginationData = {
    pagination: {
        paginationModel: { page: 10, pageSize: 10 },
    }
};